require("../../node_modules/jquery-match-height/dist/jquery.matchHeight.js");

module.exports = {
  init: () => {
    $(".matchheight").matchHeight();
    $(".matchheight2").matchHeight();
    $(".matchheight-single").matchHeight({
      target: $(".matchheight-single--target")
    });
    var update = function() {
      $.fn.matchHeight._update();
    };
    $(".matchheight .lazyload").on("load", update);
  }
};
